<template>
    <div v-if="isTgApp" class="block" style="height: 62px;"></div>
    
    <!--fixed header-->
    <div class="fixed xl:hidden lg:hidden md:hidden w-full surface-0 px-3 shadow-2 z-4 top-0 min-h-3">
        <div class="flex w-full flex-column">
            <div class="flex flex-row w-full mt-2 mb-2">
                <span class="flex flex-1 text-900 font-medium mr-3 text-2xl ">
                    {{ header[lang_].title }}
                </span>
                <span v-if="bill && bill.id" class="flex">
                    <div @click="copy(bill.id)" class="ml-2 py-1 px-2 flex text-xs border-round-md font-semibold border-2 surface-border cursor-pointer text-500 font-medium align-items-center" >
                        <span class="flex">{{get_short_id(bill.id)}}</span>
                        <span class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                    </div>
                </span>
            </div>
            <div v-if="bill && bill.date_created" class="flex w-full mb-2 text-sm text-500">
                {{ content[lang_].from }}: <span class="ml-2">{{ formatDate(bill.date_created) }}</span>
            </div>
        </div>
    </div>

    <Page>
        <template #body>
            <div v-if="(screenSize!='xl' && screenSize!='lg' && screenSize!='md')" class="block" style="height: 62px;"></div>
            <div v-if="bill" class="w-full max-w-30rem mb-3">
                <span v-if="(screenSize=='xl' || screenSize=='lg' || screenSize=='md')" class="text-900 font-medium mb-4 xl:mb-6 
                    text-3xl xl:text-6xl lg:text-5xl md:text-4xl
                    flex xl:flex lg:flex md:flex">
                    {{ header[lang_].title }}
                </span>
                <span v-if="bill.recipient && bill.recipient.fullname" class="flex flex-column mb-3">
                    <span class="flex text-500 text-sm mb-2">{{ content[lang_].recipient }}:</span>
                    <span class="flex text-800 font-medium text-lg">{{ bill.recipient.fullname }}</span>
                </span>
                <span v-if="bill && bill.amount && bill.recipient && bill.recipient.currency_code" class="flex flex-column mb-3">
                    <span class="flex text-500 text-sm mb-2">{{ content[lang_].amount }}:</span>
                    <span class="flex text-800 font-medium text-3xl">{{ get_format_amount(bill.amount.$numberDecimal, bill.recipient.currency_code) }}</span>
                </span>
                <span v-if="bill.description" class="flex flex-column mb-3">
                    <span class="flex text-500 text-sm mb-2">{{ content[lang_].description }}:</span>
                    <span class="flex text-800 font-medium text-sm">{{ bill.description }}</span>
                </span>
            </div>
            <div class="flex w-full max-w-30rem">
                <TransferCreateFromBill v-if="bill" :bill="bill" :fix_amount="fix_amount" />
            </div>
        </template>
    </Page>
</template>


<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import { useRoute } from 'vue-router'
import TransferCreateFromBill from '@/components/personal/transfer/CreateFromBill.vue' 
import Page from '@/components/sides/Page.vue'

export default {
    data() {
        return {
            header: {
                en: {title: "Invoice"} ,
                ru: {title: "Счет на оплату"} ,
            },
            content: {
                en: {
                    pay_until: "Pay until",
                    from: "From",
                    copied: "Copied",
                    recipient: "Recipient",
                    amount: "Amount",
                    description: "Description",
                },
                ru: {
                    pay_until: "Оплатить до",
                    from: "От",
                    copied: "Скопировано",
                    recipient: "Получатель",
                    amount: "Сумма",
                    description: "Описание",
                },
            },
            bill: null,
            fix_amount: false
        }
    },
    methods: {
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: this.content[this.lang_].copied, detail: text, life: 1000 })
        },
        get_short_id(id){
            return this.helper.get_short_id(id)
        },
        formatDate(value) {
            return this.helper.format_date_short(value)
        },
        get_format_amount(value, currency) {
            return this.helper.format_amount(value, currency)
        },
    },
    components: {
        TransferCreateFromBill,
        Page
    },
    computed: {
        isTgApp: function () { return this.$store.getters.StateTgApp },
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screenSize() { return this.$store.getters.StateScreenSize },
    },
    mounted() {

	},
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
        const route = useRoute()

        if(route.params.hash && route.params.hash.length>=64) this.hash = route.params.hash

        if(!this.hash) this.$router.push({ name: 'Not found' })

        const bill = await this.connect.get_bill(this.hash).then(res => res)
        if(!bill.result || !bill.data) this.$router.push({ name: 'Not found' })
        this.bill = bill.data

        if(this.bill && this.bill.amount && this.bill.amount.$numberDecimal) {
            this.fix_amount = true
        }
    },
}
</script>